// 对外导出常量 token
export const TOKEN = 'token'

// 系统登录
export const SYSTEM = 'SYSTEM'
